import type { ColumnDef } from '@tanstack/react-table';
import { createSerialColumn, getAreaColumn } from '@/components/common/DataTable';
import { formatNumber } from '@/utils/number';
import { PersonNameCell } from './PersonNameCell';
import type { AllCostMember } from '../types/billing.types';

export function getAllCostColumns(
  searchText: string | undefined,
): ColumnDef<AllCostMember, unknown>[] {
  return [
    createSerialColumn<AllCostMember>(),
    {
      accessorKey: 'name',
      header: 'ZM Name',
      cell: ({ row }) => (
        <PersonNameCell
          name={row.original.name}
          designationName={row.original.designationName}
          mobile={null}
          searchText={searchText}
        />
      ),
    },
    getAreaColumn<AllCostMember>(),
    {
      accessorKey: 'dcrClaimed',
      header: 'DCR Claimed',
      cell: ({ row }) => (
        <span className="tabular-nums">{formatNumber(row.original.dcrClaimed)}</span>
      ),
    },
    {
      accessorKey: 'dcrApproved',
      header: 'DCR Approved',
      cell: ({ row }) => (
        <span className="tabular-nums">{formatNumber(row.original.dcrApproved)}</span>
      ),
    },
    {
      accessorKey: 'expenseClaimed',
      header: 'Expense Claimed',
      cell: ({ row }) => (
        <span className="tabular-nums">{formatNumber(row.original.expenseClaimed)}</span>
      ),
    },
    {
      accessorKey: 'expenseApproved',
      header: 'Expense Approved',
      cell: ({ row }) => (
        <span className="tabular-nums">{formatNumber(row.original.expenseApproved)}</span>
      ),
    },
    {
      accessorKey: 'totalClaimed',
      header: 'Total Claimed',
      cell: ({ row }) => (
        <span className="font-medium tabular-nums">{formatNumber(row.original.totalClaimed)}</span>
      ),
    },
    {
      accessorKey: 'totalApproved',
      header: 'Total Approved',
      cell: ({ row }) => (
        <span className="font-medium tabular-nums">{formatNumber(row.original.totalApproved)}</span>
      ),
    },
  ];
}
